const i = [
  { min: 1, max: 24, position: "10%" },
  { min: 25, max: 49, position: "35%" },
  { min: 50, max: 74, position: "60%" },
  { min: 75, max: 100, position: "85%" }
];
export {
  i as DOT_RANGES
};
//# sourceMappingURL=index.es5527.js.map
